module.exports = __webpack_public_path__ + "static/media/logo-60.c3dc71b0.png";